(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
    const pageParam = parseInt(new URLSearchParams(window.location.search).get('page') || '1');
  if (pageParam > 1) {
    document.addEventListener('DOMContentLoaded', function() {
      const banner = document.querySelector('[class*="ai-collection-header"]');
      if (banner) banner.style.display = 'none';
    });
  }


  } catch(e) { console.error(e); }
})();
})();
